import axios from 'axios';

import { setAuthCookie } from 'services/authService';
import { RowWithDate } from 'components/EditableTable/types';

export const postUserHistoricalCompsDataOverrides = async (payload: {
  overrides: RowWithDate[];
  data_is_reviewed?: boolean;
}) => {
  await setAuthCookie();

  return axios.post('/api/postUserHistoricalCompsDataOverrides', payload);
};
